import { Collection } from "immutable";

export const mapNoTryOnlyGet = <K, V>(map: Collection.Keyed<K, V> | Map<K, V>, key: K): V => {
    const rv = map.get(key);
    if (rv != null) {
        return rv;
    }
    throw new Error("key not found");
};
